import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";
import { ProductVisibilityType } from "@omni/types/api/product/bff/shared/enums/productVisibilityType.enum";

const VisibilityTypeToFilter = new Set([
    ProductVisibilityType.Offline,
    ProductVisibilityType.NotAvailable,
    ProductVisibilityType.TemporaryNotAvailable
]);

const isVisible = (product: Product<ProductFieldSet.ProductTile>) => {
    return !VisibilityTypeToFilter.has(product.productVisibilityType);
};

export const filterVisible = (
    products: Array<Product<ProductFieldSet.ProductTile>>
) => {
    return products.filter(isVisible);
};
